const prefix = 'APP/';

export const INITIAL = `${prefix}INITIAL`;
export const SET_REFRESH_KEY = `${prefix}SET_REFRESH_KEY`;
export const GET_USER_SETTINGS = `${prefix}GET_USER_SETTINGS`;
